export enum routes {
  home = '/offence-report',
  addOffence = '/offence-report/add-offence',
  history = '/offence-report/history',
  isSocialCommunityUrl = '/app/content',
}

